import React, { useState, useEffect } from 'react';
import { Modal, Radio, Space, Checkbox, Divider, Button, Tooltip } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apis, apiHolder } from 'api';
import { MailActions, useActions, useAppDispatch } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { ReactComponent as ErrorIcon } from '@/images/icons/mail/error-icon.svg';
import { ReactComponent as IconClose } from '@/images/icons/mail/icon-close1.svg';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import styles from './MailReport.module.scss';
import { getIn18Text } from 'api';
export const MailReport = (props) => {
    const { mailId, hasReport = false, senderEmail, visible, setVisible } = props;
    const [alertModalVisible, setAlertModalVisible] = useState(false);
    const [radioType, setRadioType] = useState(-1);
    const [blockSender, setBlockSender] = useState(false);
    const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
    const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
    const eventApi = apiHolder.api.getEventApi();
    const dispatch = useAppDispatch();
    const mailActions = useActions(MailActions);
    useEffect(() => {
        setRadioType(-1);
    }, [mailId, visible]);
    useEffect(() => {
        if (visible) {
            setBlockSender(false);
        }
    }, [visible]);
    const handleTrust = async () => {
        var _a;
        try {
            if (!((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.onLine)) {
                message.error(getIn18Text('WANGLUOBUKEYONG'));
                return;
            }
            let successMsg = getIn18Text('SHEWEIXINRENCHENG11');
            if (blockSender) {
                const res = await mailConfApi.setBlackListOrWhiteList(senderEmail, false);
                if (res === 'exist') {
                    setAlertModalVisible(true);
                    return;
                }
                successMsg = getIn18Text('SHEWEIXINRENCHENG');
            }
            dispatch(Thunks.doMoveMail({
                mailId,
                folderId: 1,
            }));
            await mailApi.doReportOrTrustMail(mailId, 1);
            mailActions.doDeleteMailById(mailId);
            message.success(successMsg);
        }
        catch (error) {
            message.info(getIn18Text('SHEWEIXINRENSHI'));
            console.log('[report error]:', error);
        }
        finally {
            setVisible(false);
        }
    };
    const handleReport = async () => {
        var _a;
        try {
            if (!((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.onLine)) {
                message.error(getIn18Text('WANGLUOBUKEYONG'));
                return;
            }
            let successMsg = getIn18Text('JUBAOCHENGGONG\uFF0C11');
            if (blockSender && senderEmail) {
                const res = await mailConfApi.setBlackListOrWhiteList(senderEmail, true);
                if (res === 'exist') {
                    setAlertModalVisible(true);
                    return;
                }
                successMsg = getIn18Text('JUBAOCHENGGONG\uFF0C');
            }
            dispatch(Thunks.doMoveMail({
                mailId,
                folderId: 5,
            }));
            await mailApi.doReportOrTrustMail(mailId, 5, radioType);
            eventApi.sendSysEvent({
                eventName: 'mailStatesChanged',
                eventData: {
                    mark: false,
                    id: mailId,
                    type: 'redFlag',
                    hideMessage: true,
                },
                _account: '',
                eventStrData: 'unmark',
            });
            mailActions.doDeleteMailById(mailId);
            message.success(successMsg);
        }
        catch (error) {
            message.info(getIn18Text('JUBAOSHIBAI'));
            console.log('[report error]:', error);
        }
        finally {
            setVisible(false);
        }
    };
    const renderReportModal = () => (React.createElement(React.Fragment, null,
        React.createElement("h3", null, getIn18Text('QINGXUANZEJUBAO')),
        React.createElement("div", null,
            React.createElement(Radio.Group, { onChange: e => setRadioType(e.target.value), value: radioType },
                React.createElement(Space, { direction: "vertical" },
                    React.createElement(Radio, { value: 0 }, getIn18Text('FANGMAOYOUJIAN\uFF08')),
                    React.createElement(Radio, { value: 1 }, getIn18Text('SEQINGYOUJIAN')),
                    React.createElement(Radio, { value: 2 }, getIn18Text('DIAOYUYOUJIAN\uFF08')),
                    React.createElement(Radio, { value: 3 }, getIn18Text('WEIFAYOUJIAN'))),
                React.createElement(Space, { direction: "vertical" },
                    React.createElement(Radio, { value: 4 }, getIn18Text('DAIFAYOUJIAN')),
                    React.createElement(Radio, { value: 5 }, getIn18Text('TUIGUANGYOUJIAN')),
                    React.createElement(Radio, { value: 6 }, getIn18Text('QITAYOUJIAN'))))),
        React.createElement(Divider, { style: { margin: '14px 0' } }),
        React.createElement("div", null,
            React.createElement(Checkbox, { checked: blockSender, onChange: e => setBlockSender(e.target.checked) },
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    getIn18Text('JIANGFAJIANRENJIA2'),
                    React.createElement(Tooltip, { title: "\u52A0\u5165\u9ED1\u540D\u5355\u5C06\u62D2\u6536\u8BE5\u8054\u7CFB\u4EBA\u6765\u4FE1\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C" },
                        React.createElement(QuestionCircleOutlined, { style: {
                                marginLeft: 8,
                            } })))))));
    const renderTrustModal = () => (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("h3", null, getIn18Text('SHEWEIXINRENHOU')),
            React.createElement(Checkbox, { checked: blockSender, onChange: e => setBlockSender(e.target.checked) }, getIn18Text('JIANGFAJIANRENJIA')))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { visible: visible, bodyStyle: { padding: 20 }, onCancel: () => setVisible(false), onOk: hasReport ? handleTrust : handleReport, closeIcon: React.createElement(IconClose, null), destroyOnClose: true, width: 400, cancelText: getIn18Text('QUXIAO'), okText: getIn18Text('QUEDING'), okButtonProps: { disabled: radioType === -1 && !hasReport }, className: styles.reportWrap },
            React.createElement("div", { className: "ant-allow-dark" },
                React.createElement("form", null, hasReport ? renderTrustModal() : renderReportModal()))),
        React.createElement(Modal, { closable: false, visible: alertModalVisible, footer: React.createElement(Button, { type: "primary", onClick: () => setAlertModalVisible(false) }, getIn18Text('ZHIDAOLE')) },
            React.createElement("div", { style: {
                    fontWeight: 500,
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                } },
                React.createElement(ErrorIcon, { style: { marginRight: 8 } }),
                React.createElement("span", null, getIn18Text('TIANJIASHIBAI\uFF0C'))))));
};
export default MailReport;
